import useSWR from "swr";
import { getLongRunningTasks } from "./task-info-service";
import { UseTaskInfoModel } from "./types";

const useLongRunningTasks = (): UseTaskInfoModel => {
  const { data, error, isLoading, mutate } = useSWR(
    "/task/long-running",
    getLongRunningTasks,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    data: data?.results ?? [],
    isLoading,
    error,
    mutate: async () => {
      await mutate();
    },
  };
};

export default useLongRunningTasks;
